<template>
   <!-- 开票申请 -->
   <div class="issue-list">
    <!-- <p class="tips" v-if="showTips">发布须知：应淘IC发布商品政策需求，仅支持进口后7天内的商品，超期将不支持同步，可发布商品限50个，从一咻发布商品享受免费开通淘IC正品排名服务哦~
        <span @click="showTips = false">x</span>
    </p>
     -->
    <el-alert class="ab-lert" v-if="showTips" title="发布须知：应淘IC发布商品政策需求，可发布商品限50个，从一咻发布商品享受免费开通淘IC正品排名服务哦~" type="warning" @close="() => {this.showTips = false}" ></el-alert>
    <ab-list-query>
        <template #right>
            <el-row :gutter="20">
                <el-col :span="4">
                    <el-input placeholder="型号" v-model.trim="formSearch.model" clearable></el-input>
                </el-col>
                <el-col :span="4">
                    <el-input  placeholder="订单编号" v-model.trim="formSearch.custOrderNo" clearable></el-input>
                </el-col>
                <el-col :span="4">
                    <el-input  placeholder="批号" v-model.trim="formSearch.batch" clearable></el-input>
                </el-col>
                <el-col :span="4">
                    <ab-timeSearch
                        class="searchBox"
                        startSrc="进口日期起"
                        endSrc="进口日期止"
                        v-model="formSearch.updateTimeArr1"
                        @searchEvent="changeTimeRange"
                    ></ab-timeSearch>
                </el-col>
                <el-col :span="4">
                    <el-input  placeholder="品牌" v-model.trim="formSearch.brand" clearable></el-input>
                </el-col>
                <el-col :span="4" class="text-left">
                    <el-button @click="searchForm">搜索</el-button>
                    <el-button link class="btn-svg" @click="formSearch={}"><ab-svg name="qingchu"></ab-svg>清除</el-button>
                </el-col>
            </el-row>
        </template>

        <template #toolbar>
            <el-button type="primary" :loading="load.isAddLoading" :disabled="isDisabled" @click="issue">发布</el-button>
            <el-button type="primary" v-if="signedUrl" :loading="load.isAddLoading" @click="open">授权书下载</el-button>
            <el-button type="primary" v-else :loading="load.isAddLoading" @click="toSign">授权书签章</el-button>
            <el-button @click="exportFile" :loading="load.btnLoading">导出</el-button>
            <p style="float: right; margin: 14px 20px;">已发布 <span style="color: #F87243"> {{numObj.published || 0}}</span> 个 &nbsp;|&nbsp; 可发布  <span style="color: #F87243">{{numObj.canPublish || 0}} </span> 个</p>
        </template>

        <template #table>
            <ab-table
                class="materialTable"
                ref="table"
                stripe
                showEdit
                showSelection
                selectionWidth="45"
                indexWidth="50"
                widths="100"
                isFilter="operator"
                :column-list="columns"
                :table-list="tableData"
                :dataListLoading="load.isloading"
                :handleSelectionChange='handleSelectionChange'
                @filterColumns="filterColumns"
                :header-cell-class-name="cellSty"
            >
                <template #currentQty='scope'>
                    <el-input v-model="scope.row.currentQty" type="number" :disabled="!scope.row.isEdit"></el-input>      
                </template>
                <template #spec='scope'>
                    <el-input v-model="scope.row.spec" maxlength="32" :disabled="!scope.row.isEdit"></el-input>  
                </template>
                <template #batch='scope'>
                    <el-input v-model="scope.row.batch" maxlength="32" :disabled="!scope.row.isEdit"></el-input>  
                </template>
                <template #operator='scope'>
                    <el-button type="primary" link @click="editRow(scope.row)">{{scope.row.isEdit ? '保存' : '编辑'}}</el-button>                
                </template>
            </ab-table>
            
        </template>

        <template #page>
            <ab-page
                :pageTotal="page.total" 
                :currentPage='page.currentPage' 
                :pageSize="page.pageSize" 
                :pageSizes="page.pageSizes"
                @searchForm="pageSearch"
            ></ab-page>
        </template>
    </ab-list-query>
        <el-dialog
        :close-on-click-modal="false"
        class="no-min-height"
        width="80vw"
        top="0"
        @closed="closeDialog"
        title="授权书签章"
        v-model="signatureVisible">
            <iframe style="width: 100%; height: 640px" :src="parameUrl" frameborder="0" class="is-iframe"></iframe>
        </el-dialog>
   </div>
</template>

<script>
import ws from "../../utils/ws";
export default {
    name: 'ic-issue',
    data() {
        return {
            screenHeight: '',
            parameUrl: '',
            showTips: true,
            //状态汇总
            load:{
                isAddLoading:false,
                isloading:false,
                btnLoading:false,
            },
            signatureVisible: false,
            formSearch:{},
            multipleSelection:[],
            columns: [
                {
                    props: 'model',
                    labels: '型号',
                    widths: 120,
                },
                {
                    props: 'brand',
                    labels: '品牌',
                    widths: 80
                },
                {
                    props: 'qty',
                    labels: '数量',
                    widths: 60 
                },
                {
                    props: 'currentQty',
                    labels: '本次发布',
                    widths: 60,
                    slot: 'slot'
                },
                {
                    props: 'spec',
                    labels: '封装',
                    widths: 80,
                    slot: 'slot'
                },
                {
                    props: 'batch',
                    labels: '批次',
                    widths: 80,
                    slot: 'slot'
                },
                {
                    props: 'custOrderNo',
                    labels: '订单编号',
                    widths: 120,
                },
                {
                    props: 'portDate',
                    labels: '进口日期',
                    widths: 120,
                },
            ],
            tableData: [],
            page: {
                currentPage: 1,
                pageSize: 10,
                pageSizes: [10, 20, 50, 100],
                total: 0
            },
            signedUrl: '',
            numObj: {}
        }
    },
    computed:{
        isDisabled(){
            if(!this.multipleSelection.length || this.multipleSelection.length > 50) {
                return true
            }
            return false
        }
    },
    methods:{        
        showNotice(data) {
            if (data && data.typeName === "EVENT") {
                if (data.title == "Taoic授权书签署") {
                    setTimeout(()=>{
                        this.signatureVisible = false
                        this.getEsign()
                    }, 500)
                }
            }
        },
        issue() {
            let list = []
            for (let index = 0; index < this.multipleSelection.length; index++) {
                const element = this.multipleSelection[index];
                if(element.currentQty > element.qty) {
                    this.$message.error(`第 ${index + 1} 行本次发布数量不能大于最大数量`)
                    return
                }
                list.push(
                    {
                        currentQty: element.currentQty,
                        spec: element.spec,
                        batch: element.batch,
                        id: element.id
                    }
                )
            }
            this.load.isAddLoading = true
            this.$post('/cms/taoicToPublish/publish', list).then(({data}) => {
                if(data && data.code === 'C0000') {
                    this.$message.success(data.message)
                }
            }).finally(() => {
                this.load.isAddLoading = false
                this.getListData()
            })
        },
        open() {
            open(this.signedUrl)
        },
        toSign() {
            this.load.isAddLoading = true
            this.$get('/cms/taoicToPublish/toAuthorizeSign').then(({data}) => {
                if(data && data.code === 'C0000') {
                    this.parameUrl = data.result
                    this.signatureVisible = true
                }
            }).finally(() => {
                this.load.isAddLoading = false
            })
        },
        cellSty({row,column, rowIndex}) {
            if(column.property == 'currentQty') {
                return 'required-class'
            }
        },
        //日期
        changeTimeRange(obj){
            this.formSearch.updateTimeArr1=obj
            if (obj) {
                this.formSearch.portDateStart = obj[0];
                this.formSearch.portDateEnd = obj[1];
            } else {
                this.formSearch.portDateStart = "";
                this.formSearch.portDateEnd = "";
            }
        },
        filterColumns(val){
            this.columns=val
        },
        pageSearch(val){
            this.page.pageSize=val.pageSize
            this.page.currentPage=val.currentPage
            this.getListData()
        },
        //获取数据
        getListData(){
            this.load.isloading=true
            let dataList = {
                data: this.formSearch,
                pageNum: this.page.currentPage, 
                pageSize: this.page.pageSize
            }
            this.$post("/cms/taoicToPublish/list",dataList).then(({ data }) => {
                if (data && data.code === "C0000") {
                    this.tableData = data.result .list;
                    this.numObj = data.extra || {}
                    this.page.total = data.result.total;
                } else {
                    this.tableData = [];
                    this.page.total = 0;
                }
            }).finally(() => {
                this.load.isloading=false
            });
        },
        //搜索
        searchForm(){
            this.getListData()
        },
        getEsign() {
            this.$get('/cms/taoicToPublish/getTaoicEsignVo').then(({data}) => {
                this.signedUrl = data.result ? data.result.signedUrl : ''
            })
        },
        editRow(row) {
            let reg = /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/g
            let reg1 = /^[1-9]+[0-9]*$/
            if(!row.isEdit) {
                row.isEdit = true
                return
            }
            let str = ''
            if(!row.currentQty) {
                str = '本次发布数量不能为空'
            }else if(!(reg1.test(row.currentQty))) {
                str = '本次发布数量只能输入正整数'
            }else if(row.currentQty > row.qty) {
                str = '本次发布数量不能大于最大数量'
            }else if(reg.test(row.spec)) {
                str = '封装不能包含中文！'
            }else if(reg.test(row.batch)) {
                str = '批次不能包含中文！'
            }
            if(str) {
                this.$message.error(str)
                return
            }
            this.$post('/cms/taoicToPublish/mod', row).then(({data}) => {
                if(data && data.code === 'C0000') {
                    this.$message.success(data.message)
                }
            }).finally(() => {
                this.getListData()
            })
        },
        //列表选择项
        handleSelectionChange(array) {
            this.multipleSelection = array;
        },
        //导出
        exportFile() {
            this.load.btnLoading=true
            let params = {}
            let excelField = this.columns.map(e => e.props);
            params.excelField= excelField 
            params.data = this.formSearch,
            this.$post("/cms/taoicToPublish/export", params).then(({ data }) => {
                if (data && data.code === "C0000") {
                    // 创建隐藏的可下载链接
                    var eleLink = document.createElement("a");
                    eleLink.download = "";
                    eleLink.target = "_blank";
                    eleLink.style.display = "none";
                    // 字符内容转变成blob地址
                    eleLink.href = data.message;
                    // 触发点击
                    document.body.appendChild(eleLink);
                    eleLink.click();
                    // 然后移除
                    document.body.removeChild(eleLink);
                } else {
                    this.$message({type: 'error', message: data.message, offset: 380, grouping: true})
                }
            }).finally(() => {
                this.load.btnLoading=false
            });
        },
    },
    created(){
        this.getListData()
        this.getEsign()
        ws.init()
        ws.showNotice = this.showNotice
    },
    mounted(){this.screenHeight = window.screen.height}
}
</script>

<style lang="scss">
.issue-list{
    .tips {
        background-color: #facd91;
        text-align: center;
        font-size: 12px;
        height: 20px;
        line-height: 20px;
        color: #3b3a39;
        span{
            float: right;
            margin-right: 20px;
            cursor: pointer;
            font-size: 16px;
            margin-top: -2px;
            &:hover{
                opacity: .7;
            }
        }
    }
    .el-menu.el-menu--horizontal{
        display: none;
    }
    .required-class::before{
        content: '*';
        height: 4px;
        width: 4px;
        position: absolute;
        color: red;
    }
}
</style>